import { createSelector } from '@ngrx/store';
import * as fromVehicle from '../reducers/vehicles-detail.reducer';
import { selectVehicleState } from '../reducers';

export const getVehicleStatsValues = () =>
  createSelector(selectVehicleState, fromVehicle.getVehicleStats);

export const getVehicleLoading = () =>
  createSelector(selectVehicleState, fromVehicle.getVehicleLoading);

export const getVehicleTypeDetail = () =>
  createSelector(selectVehicleState, fromVehicle.getVehicleTypeDetail);
